import { Bell, X } from 'lucide-react';
import { css } from 'styled-system/css';
import { LogoMark } from '../../ui/logo/LogoMark';
import { StreamedComment } from './StreamedComment';

export function CommentsPanel() {
  return (
    <div
      className={css({
        width: { base: '54%', md: '46%' },
        flexShrink: 0,
        display: 'flex',
        minHeight: 0,
        padding: { base: '2.5', md: '4' },
      })}
    >
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          background: 'bg.surface',
          border: '1px solid token(colors.border.hairline)',
          borderRadius: '12px',
          overflow: 'hidden',
        })}
      >
        <div
          className={css({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingInline: '3',
            height: '36px',
            flexShrink: 0,
          })}
        >
          <span
            className={css({
              fontSize: 'sm',
              fontWeight: 'semibold',
              color: 'text.primary',
            })}
          >
            Comments
          </span>
          <span
            className={css({
              display: 'flex',
              alignItems: 'center',
              gap: '2.5',
              color: 'text.faint',
              '& > svg': { width: '12px', height: '12px' },
            })}
          >
            <Bell />
            <X />
          </span>
        </div>

        <div
          className={css({
            display: 'flex',
            gap: '4',
            paddingInline: '3',
            borderBottom: '1px solid token(colors.border.hairline)',
            flexShrink: 0,
          })}
        >
          <span
            className={css({
              fontSize: '2xs',
              color: 'text.primary',
              paddingBottom: '2',
              borderBottom: '1px solid token(colors.prism.violet)',
              marginBottom: '-1px',
            })}
          >
            All comments
          </span>
          <span
            className={css({
              fontSize: '2xs',
              color: 'text.faint',
              paddingBottom: '2',
            })}
          >
            For you
          </span>
        </div>

        <div
          className={css({
            padding: '3',
            minHeight: 0,
            overflow: 'hidden',
          })}
        >
          <div
            className={css({
              display: 'flex',
              gap: '2.5',
              padding: '3',
              border: '1px solid token(colors.border.hairline)',
              borderRadius: '10px',
              background: 'bg.sunken',
            })}
          >
            <span
              className={css({
                width: '22px',
                height: '22px',
                borderRadius: 'full',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'ink.0',
                background: 'ink.950',
              })}
            >
              <LogoMark size={20} prism />
            </span>
            <div className={css({ minWidth: 0, flex: 1 })}>
              <div
                className={css({
                  display: 'flex',
                  alignItems: 'baseline',
                  gap: '2',
                })}
              >
                <span
                  className={css({
                    fontSize: 'xs',
                    fontWeight: 'semibold',
                    color: 'text.primary',
                  })}
                >
                  Exis Agent
                </span>
                <span
                  className={css({
                    fontFamily: 'mono',
                    fontSize: '2xs',
                    color: 'text.faint',
                  })}
                >
                  11:07 PM
                </span>
              </div>
              <StreamedComment text="Filled missing closes for AAPL, MSFT, NVDA, and AMZN. Four cells proposed. Review when you are ready." />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
